import { RoomType } from '$/GraphQL/schema/schema';
import React from 'react';

import { WebinarPlayerContext } from '$/components/WebinarPlayer/context';
import { ZoomScaleProviderContext } from './Timeline/ZoomScaleProviderContext';
import { WebinarRoom } from '../Rooms/Rooms';

const RoomMarkers: React.FC = () => {
  const { colors, rooms, timelineComponents } = React.useContext(WebinarPlayerContext);
  const { zoomScale, x } = React.useContext(ZoomScaleProviderContext);

  if (!rooms) return null;
  const roomsOfLive = rooms.filter((room) => room.caps.inSession);

  const height = timelineComponents.time.offset;

  return (
    <g>
      {roomsOfLive!.map((room: WebinarRoom, index: number) => (
        <React.Fragment key={room.type}>
          {room.type === RoomType.Presentation && (
            <rect
              x={room && zoomScale!(room.appearAt)}
              y={0}
              height={height}
              width={
                room &&
                (zoomScale!(roomsOfLive[index + 1].appearAt) ?? 1) -
                  (zoomScale!(room.appearAt) ?? 1)
              }
              fill={colors.presentationRoom}
            />
          )}
          <rect x={zoomScale!(room.appearAt)} y={0} height={height} width={1} fill={colors.room} />
        </React.Fragment>
      ))}
      <rect x={zoomScale!(rooms.domain[1])} y={0} height={height} width={1} fill={colors.room} />
      {timelineComponents.title &&
        roomsOfLive.map((room: WebinarRoom) => (
          <text
            key={room.type}
            textAnchor={room.anchor}
            alignmentBaseline='middle'
            x={zoomScale ? zoomScale(room.anchorAt!) : x!(room.anchorAt!)}
            y={timelineComponents.title!.offset + timelineComponents.title!.height / 2}
            textRendering='geometricPrecision'
            fill={colors.text}
            fontSize={12}
          >
            {room.title}
          </text>
        ))}
    </g>
  );
};

export default RoomMarkers;
